'use client'

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import posthog from "posthog-js";

export function BlogHeaderActions() {
    return (
        <>
            <Link
                href="/checklist-sopravvissuto?utm_source=blog&utm_medium=header&utm_campaign=checklist_lead"
                onClick={() => posthog.capture('click_checklist_lead', {
                    location: 'blog_header',
                    value_prop: '12 controlli settimanali per non perdere provvigioni'
                })}
            >
                <Button variant="outline" size="sm" className="border-honey-400 bg-transparent text-honey-200 hover:bg-honey-900/30 hover:text-honey-100">
                    <Download className="w-4 h-4 mr-2" />
                    Checklist Gratis
                </Button>
            </Link>
            <Link
                href="/sign-in"
                onClick={() => posthog.capture('click_login', { location: 'blog_header' })}
            >
                <Button variant="outline" size="sm" className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800 hover:text-white">
                    Accedi
                </Button>
            </Link>
            <Link
                href="/cta?type=trial&source=blog_header"
                onClick={() => posthog.capture('click_prova_gratis', { location: 'blog_header' })}
            >
                <Button size="sm" className="bg-indigo-600 text-white hover:bg-indigo-500">
                    Prova Gratis
                </Button>
            </Link>
        </>
    )
}
